import {
  SESSION_CHANGED,
  SESSION_DATA_LOADING,
  SESSION_DATA_READY,
  SESSION_DATA_FAILED,
} from "../actions/authSessionAction";
const initialState = { sessionId: null, status: "anonymous", error: null, external: false };
export const authSessionReducer = (state = initialState, action) => {
  switch (action.type) {
    case SESSION_CHANGED:
      return {
        ...initialState,
        sessionId: action.payload.sessionId,
        status: action.payload.sessionId ? "loading" : "anonymous",
        external: !!action.payload.external,
      };
    case SESSION_DATA_LOADING:
      return { ...state, status: "loading", error: null };
    case SESSION_DATA_READY:
      return { ...state, status: "ready", error: null };
    case SESSION_DATA_FAILED:
      return { ...state, status: "error", error: action.payload.code };
    default:
      return state;
  }
};
